import { IconX } from 'featherico';
import { componentWithClassName } from '../../services/Component';
import Button from '../Button';
import { DeprecatedButtonContainer } from '../ButtonContainer';
import { Card } from '../Cards';
import styles from './style.m.less';

export const Header = componentWithClassName('div', styles.header);
export const Heading = componentWithClassName('h1', styles.heading);
export const Paragraph = componentWithClassName('p', styles.paragraph);
export const CardBox = ({ children }) => <Card className={styles.box}>{children}</Card>;
export const CtaContainer = componentWithClassName(DeprecatedButtonContainer, styles.buttonContainer);
export const CloseButton = ({ onClick }) => (
    <Button kind="PLAIN" onClick={onClick}>
        <IconX />
    </Button>
);

export const Container = ({ children, aboveText }) => (
    <>
        {aboveText && <div className={styles.aboveText}>{aboveText}</div>}
        <CardBox>{children}</CardBox>
    </>
);
